import removeThousandsSeparator from './removeThousandsSeparator';

/**
 * Parses a formatted number string (with or without thousands separators) into a number.
 *
 * @param {string} value - The formatted number string to parse.
 * @returns {number | null} The parsed number, or null if the input is invalid.
 *
 * @example
 * parseFormattedNumber('1,234,567.89');
 * // Returns 1234567.89
 *
 */
const parseFormattedNumber = (value: string): number | null => {
  const cleanedValue = removeThousandsSeparator(value);

  if (!cleanedValue.trim()) return null;

  const parsedNumber = Number(cleanedValue);

  return isFinite(parsedNumber) ? parsedNumber : null;
};

export default parseFormattedNumber;
